import { render, staticRenderFns } from "./DetalheClientesDevolucaoImpropria.vue?vue&type=template&id=2824e24e&scoped=true&"
import script from "./DetalheClientesDevolucaoImpropria.vue?vue&type=script&lang=js&"
export * from "./DetalheClientesDevolucaoImpropria.vue?vue&type=script&lang=js&"
import style0 from "./DetalheClientesDevolucaoImpropria.vue?vue&type=style&index=0&id=2824e24e&scoped=true&lang=css&"
import style1 from "./DetalheClientesDevolucaoImpropria.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2824e24e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VContainer,VIcon,VListItem,VListItemContent,VRow,VTooltip})
